import {
  createContext,
  createElement,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { create } from "zustand";
import createGeneralSlice, {
  GeneralState,
} from "./GeneralStore/createGeneralSlice";
const globalStore = create<GeneralState>((...actions) => ({
  ...createGeneralSlice(...actions),
}));
const InitialContent = createContext<Partial<GeneralState> | null>(null);
/** Request-specific first render: never write one visitor's server data into a shared store. */
export function GeneralContentProvider({
  data,
  children,
}: {
  data: Partial<GeneralState>;
  children: ReactNode;
}) {
  const [initializedData, setInitializedData] =
    useState<Partial<GeneralState> | null>(null);
  useEffect(() => {
    globalStore.setState(data);
    setInitializedData(data);
  }, [data]);
  return createElement(
    InitialContent.Provider,
    { value: initializedData === data ? null : data },
    children,
  );
}
function useGeneralState<T = GeneralState>(
  selector?: (state: GeneralState) => T,
): T {
  const state = globalStore();
  const initial = useContext(InitialContent);
  const current = initial ? { ...state, ...initial } : state;
  return selector ? selector(current) : (current as T);
}
const useGeneralStore = Object.assign(useGeneralState, globalStore);
export default useGeneralStore;
